import { render, staticRenderFns } from "./NewCategoriesTabs.vue?vue&type=template&id=2b167431&scoped=true&"
import script from "./NewCategoriesTabs.vue?vue&type=script&lang=js&"
export * from "./NewCategoriesTabs.vue?vue&type=script&lang=js&"
import style0 from "./NewCategoriesTabs.vue?vue&type=style&index=0&id=2b167431&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b167431",
  null
  
)

export default component.exports